export const profile = {
  Edit_your_profile: "Modifier votre profil",
  Logout: "Déconnexion",
  Profile: "Profil",
  language: "Langue",
} as const;
